<template>
  <div>
    <span :class="{ 'text-left': true, 'required': required }">
      {{ label }}
    </span>
    <vue-simple-suggest
    v-model="selectedSearchResult"
    :display-attribute="display_attribute"
    :value-attribute="value_attribute"
    :list="getSuggestionList"
    mode="select"
    :destyled=false
    >
      <input
      class="custom-typeahead-search input-control"
      v-model="text" 
      type="search"
      :placeholder="placeholder"
      required
      >
     </vue-simple-suggest>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS

export default {
  name: "LabelTextField",
  components: {
    VueSimpleSuggest
  },
  props: {
    label: String,
    placeholder: String,
    required: Boolean,
    apiEndpoint: String,
    options: {
      type:String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: 41
    },
    type:{
      type:String,
      default:'search'
    },
    display_attribute: {
      type:String,
      default:'name'
    },
    value_attribute: {
      type:String
    }
  },
  data() {
    return {
      text: '',
      selectedSearchResult: ''
    }
  },
  watch: {
    text: function () {
      this.$emit('change', this.text)
      if (this.text===''){
        this.$emit('clear');
      }
    },
    selectedSearchResult: function() {
      this.$emit('select', this.selectedSearchResult);
    }
  },
  methods:{
    getSuggestionList(text) {
          return fetch(`/api/v1/search/${this.apiEndpoint}/${text}/5/${this.options}`, { method: 'GET' })
          .then(response => response.json())
          .then(json => json.data); 
      },

  }
}
</script>

<style scoped>
span {
  display: flex;
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  padding-bottom: 0.5rem;
}

.required::after {
  content: "*";
  margin-left: 0.25rem;
  color: red;
}
</style>